import { render, staticRenderFns } from "./ChangePasswordPanel.vue?vue&type=template&id=6ed3a7c6&"
import script from "./ChangePasswordPanel.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports